<p-table
	[value]="paginationResult.entities"
	[lazy]="true"
	(onLazyLoad)="loadData($event)"
	[rows]="paginationRequest.pageSize"
	[totalRecords]="paginationResult.filteredEntities"
	[rowsPerPageOptions]="[10, 20, 30, 40, 50]"
	[paginator]="true"
	[(selection)]="selectedEntities"
	[loading]="loading"
	[rowHover]="true"
	[showCurrentPageReport]="true"
	dataKey="name"
	currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}"
	class="custom-table"
	styleClass="p-datatable-striped"
>
	<!-- #region TABLE TITLE DEFINITION -->
	<ng-template pTemplate="caption">
		<div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
			{{ 'tableManagement.cardsConsumption.cardConsumptionsManagement' | translate }}
		</div>
	</ng-template>
	<!-- #endregion TABLE TITLE DEFINITION -->

	<!-- #region TABLE COLUMN DEFINITION -->
	<ng-template pTemplate="header">
		<tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
			<!-- CARD -->
			@if (showCardColumn) {
				<th pSortableColumn="card.number">
					<div class="d-flex align-items-center h-100">
						<!-- COLUMN TITLE -->
						<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
							{{ 'tableManagement.cardsConsumption.card' | translate }}
						</div>
						<!-- COLUMN SORT && FILTER ICONS -->
						<div class="d-flex align-items-center h-100">
							<p-sortIcon field="card.number"></p-sortIcon>
							<p-columnFilter
								field="card"
								type="text"
								matchMode="contains"
								placeholder="{{ 'general.search' | translate }}"
								display="menu"
								[showMatchModes]="false"
								[showOperator]="false"
								[showAddButton]="false"
							>
							</p-columnFilter>
						</div>
					</div>
				</th>
			}

			<!-- CARD -->
			@if (showCardColumn) {
				<th pSortableColumn="card.vehicle.name">
					<div class="d-flex align-items-center h-100">
						<!-- COLUMN TITLE -->
						<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
							{{ 'control-panel.vehicles.licensePlate' | translate }}
						</div>
						<!-- COLUMN SORT && FILTER ICONS -->
						<div class="d-flex align-items-center h-100">
							<p-sortIcon field="card.vehicle.name"></p-sortIcon>
							<p-columnFilter
								field="card"
								type="text"
								matchMode="contains"
								placeholder="{{ 'general.search' | translate }}"
								display="menu"
								[showMatchModes]="false"
								[showOperator]="false"
								[showAddButton]="false"
							>
							</p-columnFilter>
						</div>
					</div>
				</th>
			}

			<!-- IMPORT VALUE -->
			<th pSortableColumn="amount">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.amount' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="amount"></p-sortIcon>
						<p-columnFilter
							field="amount"
							type="numeric"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- CONSUMPTION DATE -->
			<th pSortableColumn="consumptionDate">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.date' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="consumptionDate"></p-sortIcon>
					</div>
				</div>
			</th>

			<!-- CONSUMPTION TYPE -->
			@if (showCardColumn) {
				<th pSortableColumn="consumptionType">
					<div class="d-flex align-items-center h-100">
						<!-- COLUMN TITLE -->
						<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
							{{ 'tableManagement.cardsConsumption.consumptionType' | translate }}
						</div>
						<!-- COLUMN SORT && FILTER ICONS -->
						<div class="d-flex align-items-center h-100">
							<p-sortIcon field="consumptionType"></p-sortIcon>
							<p-columnFilter
								field="consumptionType"
								type="text"
								matchMode="contains"
								placeholder="{{ 'general.search' | translate }}"
								display="menu"
								[showMatchModes]="false"
								[showOperator]="false"
								[showAddButton]="false"
							>
							</p-columnFilter>
						</div>
					</div>
				</th>
			}

			<!-- CONSUMPTION DETAIL FIELDS -->
			<!-- LITERS -->
			<th pSortableColumn="liters">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.litres' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="liters"></p-sortIcon>
						<p-columnFilter
							field="liters"
							type="numeric"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- KMS -->
			<th pSortableColumn="kms">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.km' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="kms"></p-sortIcon>
						<p-columnFilter
							field="kms"
							type="numeric"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- DIFF KMS -->
			<th pSortableColumn="difKms">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.diffKms' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="difKms"></p-sortIcon>
						<p-columnFilter
							field="difKms"
							type="numeric"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- DIFF DAYS -->
			<th pSortableColumn="difDays">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.diffDays' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="difDays"></p-sortIcon>
						<p-columnFilter
							field="difDays"
							type="numeric"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- DIFF CONSUMPTION -->
			<th pSortableColumn="difConsumption">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.diffConsumption' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="difConsumption"></p-sortIcon>
						<p-columnFilter
							field="difConsumption"
							type="numeric"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- KMS COST -->
			<th pSortableColumn="kmsCost">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.kmsCost' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="kmsCost"></p-sortIcon>
						<p-columnFilter
							field="kmsCost"
							type="numeric"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- LITER COST -->
			<th pSortableColumn="literCost">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.literCost' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="literCost"></p-sortIcon>
						<p-columnFilter
							field="literCost"
							type="numeric"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- CARD BILLING -->
			<th pSortableColumn="cardBilling.invoiceNumber">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.invoiceNumber' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="cardBilling.invoiceNumber"></p-sortIcon>
						<p-columnFilter
							field="invoiceNumber"
							type="numeric"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- CARD BILLING DATE -->
			<th pSortableColumn="cardBilling.billingDate">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.billingDate' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="cardBilling.billingDate"></p-sortIcon>
						<p-columnFilter
							field="billingDate"
							type="numeric"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- PLACE -->
			<th pSortableColumn="place">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.place' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="place"></p-sortIcon>
						<p-columnFilter
							field="place"
							type="numeric"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- PLACE CITY -->
			<th pSortableColumn="placeCity">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.cardsConsumption.placeCity' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="placeCity"></p-sortIcon>
						<p-columnFilter
							field="placeCity"
							type="numeric"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- DELETE -->
			<th class="button-column"></th>
		</tr>
	</ng-template>

	<!-- #endregion TABLE COLUMN DEFINITION -->

	<!-- #region TABLE BODY -->
	<ng-template pTemplate="body" let-entity>
		<tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(entity)">
			<!-- CARD -->
			@if (showCardColumn && entity.card) {
				<td>
					{{ entity.card?.number }}
				</td>
			}

			<!-- CARD -->
			@if (showCardColumn && !entity.card) {
				<td>
					{{ 'tableManagement.cardsConsumption.manualRefueling' | translate | uppercase }}
				</td>
			}
			<!-- PLATE -->
			@if (showCardColumn) {
				<td>
					{{ entity.vehicle?.name }}
				</td>
			}

			<!-- IMPORT VALUE -->
			<td>
				{{ entity.amount | number: '1.2-2' }}
			</td>

			<!-- CONSUMPTION DATE -->
			<td>
				{{ entity.consumptionDate | date: 'dd/MM/yyyy' }}
			</td>

			@if (showCardColumn) {
				<td>
					{{ entity.consumptionType }}
				</td>
			}

			<!-- LITERS -->
			<td>
				{{ entity.liters | number: '1.2-2' }}
			</td>

			<!-- KMS -->
			<td>
				{{ entity.kms }}
			</td>

			<!-- DIFF KMS -->
			<td>
				{{ entity.difKms }}
			</td>

			<!-- DIFF DAYS -->
			<td>
				{{ entity.difDays }}
			</td>

			<!-- DIFF CONSUMPTION -->
			<td>
				{{ entity.difConsumption | number: '1.2-2' }}
			</td>

			<!-- KMS COST -->
			<td>
				{{ entity.kmsCost | number: '1.2-2' }}
			</td>

			<!-- LITER COST -->
			<td>
				{{ entity.literCost | number: '1.2-2' }}
			</td>

			<td>
				{{ entity.cardBilling?.invoiceNumber }}
			</td>

			<td>
				{{ entity.cardBilling?.billingDate | date: 'dd/MM/yyyy' }}
			</td>

			<td>
				{{ entity.place }}
			</td>

			<td>
				{{ entity.placeCity }}
			</td>

			<!-- DELETE -->
			<td class="button-column">
				@if (isDisabledGranted) {
					<button type="button" class="btn custom-table-remove-button" (click)="onDeleteCardConsumption(entity)">
						<svg-icon
							src="assets/icons/trash.svg"
							class="d-flex flex-wrap custom-table-remove-button-icon"
							[svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
						></svg-icon>
					</button>
				}
			</td>
		</tr>
	</ng-template>
	<!-- #endregion TABLE BODY -->

	<!-- #region TABLE EMPTY MESSAGE -->
	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="17" class="p-0">
				<div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
					{{ 'table.tableEmptyMessage' | translate }}!
				</div>
			</td>
		</tr>
	</ng-template>
	<!-- #endregion TABLE EMPTY MESSAGE -->

	<!-- #region TABLE FOOTER -->
	<ng-template pTemplate="footer">
		<tr>
			<td colspan="17" class="p-0">
				<div class="d-flex flex-row align-items-center p-3 gap-3">
					<!-- ADD CardConsumption BUTTON -->
					@if (isCreateGranted) {
						<app-table-add-button
							[text]="'tableManagement.cardsConsumption.cardConsumption' | translate"
							(btnClick)="create(true)"
						></app-table-add-button>
					}

					<div class="d-flex flex-row" style="margin-left: auto">
						<!-- UPLOAD FILE FORM BUTTON -->
						<div
							class="buttonTableExcel custom-image-button"
							pTooltip="{{ 'tableManagement.cardsConsumption.cardsConsumptionProcess' | translate }}"
							tooltipPosition="top"
							(click)="showFileForm()"
						>
							<svg-icon
								src="assets/icons/upload-file.svg"
								[svgStyle]="{ 'height.px': 30, 'width.px': 30 }"
							></svg-icon>
						</div>
						<!-- SYNC PROCESS LOGS BUTTON -->
						<div
							class="buttonTableExcel custom-image-button"
							pTooltip="{{ 'tableManagement.cardsConsumption.syncProcessLogs' | translate }}"
							tooltipPosition="top"
							(click)="openSyncLogsDialog()"
						>
							<svg-icon
								src="assets/icons/upload-file.svg"
								[svgStyle]="{ 'height.px': 30, 'width.px': 30 }"
							></svg-icon>
						</div>
						<!--  EXCEL BUTTON -->
						<app-table-excel-button class="buttonTableExcel" (btnClick)="exportExcel()"></app-table-excel-button>
					</div>
				</div>
			</td>
		</tr>
	</ng-template>
	<!-- #endregion TABLE FOOTER -->
</p-table>

@if (vehicle) {
	<div class="summary-container">
		<app-card-consumption-summary [vehicle]="vehicle"></app-card-consumption-summary>
	</div>
}

<!-- FINE FORM -->
<app-cardConsumption-form
	[card]="card"
	[vehicle]="vehicle"
	(saveCompleted)="onSaveCompleted()"
></app-cardConsumption-form>

<!-- UPLOAD FILE FORM -->
<app-upload-file-form
	(refreshTable)="refresh()"
	[renewalType]="renewalType"
	[title]="fileFormTitle"
></app-upload-file-form>

<!-- SYNC PROCESS LOGS DIALOG -->
<p-dialog
	[(visible)]="showSyncLogs"
	[modal]="true"
	[style]="{ width: '95vw', height: '90vh' }"
	[draggable]="false"
	[resizable]="false"
	[header]="'tableManagement.cardsConsumption.syncProcessLogs' | translate"
>
	@if (showSyncLogs) {
		<app-sync-process-logs></app-sync-process-logs>
	}
</p-dialog>

<p-confirmDialog
	#saveEventDialog
	[header]="'confirm.critic' | translate"
	[message]="'control-panel.delete-dialog.message' | translate"
	class="custom-dialog"
	icon="pi pi-exclamation-triangle"
>
	<ng-template pTemplate="footer">
		<!-- REJECT BUTTON -->
		<button (click)="saveEventDialog.onReject()" class="custom-button">
			{{ 'general.no' | translate }}
		</button>
		<!-- ACCEPT BUTTON -->
		<button (click)="saveEventDialog.onAccept()" class="custom-button">
			{{ 'general.yes' | translate }}
		</button>
	</ng-template>
</p-confirmDialog>
